import { render, staticRenderFns } from "./luckyDraw.vue?vue&type=template&id=f2b223ce&scoped=true&"
import script from "./luckyDraw.vue?vue&type=script&lang=js&"
export * from "./luckyDraw.vue?vue&type=script&lang=js&"
import style0 from "./luckyDraw.vue?vue&type=style&index=0&id=f2b223ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b223ce",
  null
  
)

export default component.exports